import {
  Component,
  ContentChild,
  Directive,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ThemeList, ThemeService } from '../../service/theme.service';

@Directive({
  selector: '[appCustomModalHeader]',
  standalone: false,
})
export class CustomModalHeaderDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
@Directive({
  selector: '[appCustomModalBody]',
  standalone: false,
})
export class CustomModalBodyDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
@Directive({
  selector: '[appCustomModalFooter]',
  standalone: false,
})
export class CustomModalFooterDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss'],
  standalone: false,
})
export class ModalConfirmationComponent {
  @ContentChild(CustomModalHeaderDirective)
  customHeader: CustomModalHeaderDirective;

  @ContentChild(CustomModalBodyDirective)
  customBody: CustomModalBodyDirective;

  @ContentChild(CustomModalFooterDirective)
  customFooter: CustomModalFooterDirective;

  subscription: Subscription[] = [];
  themeList?: ThemeList;
  @Input() title: string;
  @Input() body: string;
  @Input() btnCancel: string;
  @Input() btnConfirm: string;
  @Input() laddaLoading: boolean;
  @Input() disableBtn: boolean;
  @Input() validate = false;

  @Output() closeModal = new EventEmitter();
  @Output() confirmModal = new EventEmitter();

  constructor(
    private themeService: ThemeService,
    private modalService: NgbModal,
  ) {
    this.subscription.push(
      this.themeService.data.subscribe((theme) => {
        this.themeList = theme;
      }),
    );
  }

  close(): void {
    // I have to emit closeModal event before dismiss modal. Otherwise
    //   target component will not received closeModal event.
    try {
      this.closeModal.emit();
    } catch (e) {}
    try {
      this.modalService.dismissAll();
    } catch {}
  }

  submit(): void {
    this.confirmModal.emit();
  }
}
